import { FormBuilder } from 'components/FormBuilder';
import { ApiResponse } from 'models/formBuilder';
import Button from 'components/button/Button';
import { Modal } from 'components/modal/Modal';
import { Spinner } from 'components/spinner/Spinner';
import { Form, Formik } from 'formik';
import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openModal, selectModalState, ModalTypes } from 'reducers/modal';
import { CurrencyOptionsModal } from './CurrencyOptionsModal';
import logger from 'helpers/logger';

type AddFundsProps = {
    setAddFunds: React.Dispatch<SetStateAction<boolean>>;
};

const AddFunds: React.FC<AddFundsProps> = ({ setAddFunds }) => {
    const dispatch = useDispatch();
    const modalState = useSelector(selectModalState);
    const { t } = useTranslation('crypto');

    const currencyOptionModal = {
        title: t('changeDefaultCurrency'),
        primaryButton: t('confirm', { ns: 'common' }),
        secondaryButton: t('cancel', { ns: 'common' }),
        handlePrimary: () => {
            logger.log('primary clicked');
        },
        handleSecondary: () => {
            logger.log('secondary clicked');
        },
    };

    const initialValues = {
        account: '',
        cardType: '',
        amount: null,
    };

    const handleSubmit = (values: any) => {
        logger.log(values);
    };

    return (
        <Formik onSubmit={handleSubmit} initialValues={initialValues}>
            <div className="AddFunds">
                <Form className="FormBuilderForm">
                    <h2
                        onClick={() => {
                            setAddFunds(false);
                        }}
                        className="TempBack"
                    >
                        {t('back', { ns: 'common' })}
                    </h2>
                    <h1 className="notranslate" translate="no">{t('addFunds')}</h1>
                    <p className="LightBlue notranslate" translate="no">{t('linkAccountToTrade')}</p>
                    <FormBuilder
                        loadingFallback={<Spinner />}
                        data={getAddFundsData(t)}
                        additionalData={{
                            account: [
                                { label: 'Personal account', key: 'personal' },
                                { label: 'Business account', key: 'business' },
                            ],
                            cardType: [
                                { label: 'Visa', key: 'Visa' },
                                { label: 'Mastercard', key: 'Mastercard' },
                            ],
                        }}
                    />
                    <Button type="submit" className="AddFundsBtn notranslate">
                        {t('submit', { ns: 'common' })}
                    </Button>
                </Form>
                <div className="Divider"></div>
                <p className="LightBlue notranslate" translate="no">{t('defaultCurrency')}</p>
                <div className="CurrencyOptions">
                    <img src={''} alt="currency" />
                    <div>
                        <h3>GBP</h3>
                        <p className="notranslate" translate="no">{t('activityCurrency', { ns: 'dashboard' })}</p>
                        <Button
                            priority="secondary"
                            onClick={() =>
                                dispatch(
                                    openModal({
                                        modalType: ModalTypes.CRYPTO_CURRENCY_SELECT,
                                        data: null,
                                    })
                                )
                            }
                        >
                            {t('currencyOptions')}
                        </Button>
                    </div>
                </div>
                {modalState.modalType === 'CRYPTO_CURRENCY_SELECT' && (
                    <Modal
                        title={currencyOptionModal.title}
                        primaryButton={currencyOptionModal.primaryButton}
                        secondaryButton={currencyOptionModal.secondaryButton}
                        handlePrimary={currencyOptionModal.handlePrimary}
                        handleSecondary={currencyOptionModal.handleSecondary}
                    >
                        <CurrencyOptionsModal />
                    </Modal>
                )}
            </div>
        </Formik>
    );
};

export { AddFunds };

const getAddFundsData = (t: (key: string, options?: any) => any): ApiResponse<any> => ({
    id: 0,
    details: {},
    metadata: [
        {
            name: 'account',
            type: 'singleselect',
            label: t('selectAccount'),
            bRemoteDataSource: false,
        },
        {
            name: 'cardType',
            type: 'singleselect',
            label: t('cardType'),
            bRemoteDataSource: false,
        },
        {
            name: 'amount',
            type: 'number',
            label: t('amount'),
            bRemoteDataSource: false,
        },
    ],
    status: '1',
    errors: [],
});
